import Swal from 'sweetalert2'

const fire = (config) => {

    // Overwritting swal config params
    if (config.customClass === undefined){
        config.customClass = 'sherpa-alert'
    }

    // Only default the icon when the caller did not ask for one. This used to overwrite it
    // unconditionally, so every fire({icon:'error'}) in the app rendered without an icon and an
    // error modal looked exactly like a success one.
    if (config.icon === undefined) {
        config.icon = ''
    }

    return Swal.fire({
        ...config,
        heightAuto: false
    })
}

const close = () => {
    return Swal.close()
}

const isLoading = () => {
    return Swal.isLoading()
}

export default {
    fire,
    close,
    isLoading
}
